// node modules
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useDispatch } from 'react-redux';
import { stringify } from 'qs';
import classNames from 'classnames';

// app modules: actions
import { loadSearchView } from 'actions/search';

// app modules: components
import SearchField from 'components/SearchField';

// app modules: services
import formatter from 'services/formatter';
import history from 'services/history';

// assets
import CssSearchIn from './SearchIn.scss';

function SearchInPerson(props) {
  const { name, className } = props;
  useStyles(CssSearchIn);
  const dispatch = useDispatch();
  const [query, setQuery] = useState('');

  const onInputChange = event => {
    setQuery(formatter.removeSmartCharacters(event.target.value));
  };

  const onSubmit = event => {
    event.preventDefault();

    const queryParams = stringify(
      { q: query, authors: [name] },
      {
        encodeValuesOnly: true,
      },
    );
    history.push(`/search?${queryParams}`, { referrer: 'Author', section: 'Search' });
  };

  const onInputFocus = () => {
    dispatch(loadSearchView());
  };

  const searchInClassName = classNames('searchIn', className);

  return (
    <form onSubmit={onSubmit} className={searchInClassName}>
      <div className="searchIn__field">
        <SearchField
          name="q"
          label="Search this author"
          className="searchIn__input"
          onChange={onInputChange}
          onFocus={onInputFocus}
          onSubmit={onSubmit}
          value={query}
          spellCheck={false}
          data-cy="person-searchbox"
        />
      </div>
    </form>
  );
}

SearchInPerson.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SearchInPerson.defaultProps = {
  className: '',
};

export default SearchInPerson;
